module.exports = __webpack_public_path__ + "static/pie9-43403b6fd13066d40533007c7a9ea9cf.png";